<template>
    <div class="flex items-center">
        <button
            :id="props.vid"
            type="button"
            role="checkbox"
            :aria-checked="!!checked"
            :aria-label="label || undefined"
            :data-state="checked ? 'checked' : 'unchecked'"
            class="flex gap-x-2"
            :disabled="props.disabled"
            :class="{ 'cursor-not-allowed': props.disabled }"
            @click="!props.disabled && handleChange(value ? value : !value)"
        >
            <slot v-bind="{ checked }">
                <div
                    :value="checked"
                    :class="{
                        'border-muval-gray-1 bg-muval-gray-1': checked,
                        'border-muval-gray-4 bg-white': !checked,
                    }"
                    class="shadow-muval-5 hover:border-muval-gray-1 relative flex h-5 w-5 items-center rounded-[2px] border transition focus:outline-hidden focus-visible:outline-hidden dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:hover:ring-blue-600 dark:focus:ring-blue-600"
                >
                    <SvgIcon
                        name="system-check"
                        class="mx-auto size-5 text-white"
                        :class="!checked ? 'hidden' : ''"
                    />
                </div>
                <span
                    v-if="label"
                    :class="props.labelClass"
                    v-text="label"
                />
            </slot>
        </button>
    </div>
</template>

<script setup>
import { useField } from 'vee-validate';
import { idGen } from '@utilities/idGen';

const props = defineProps({
    modelValue: {
        type: null,
        required: true,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
    value: {
        type: String,
        required: false,
        default: null,
    },
    label: {
        type: String,
        required: false,
        default: null,
    },
    labelClass: {
        type: String,
        required: false,
        default: 'text-sm',
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const { vid } = toRefs(props);

const { checked, handleChange } = useField(vid.value || '', undefined, {
    type: 'checkbox',
    checkedValue: props.value || true,
    uncheckedValue: props.value ? null : false,
    syncVModel: true,
});
</script>

<style scoped>
button {
    background: none;
    border: none;
    font-size: 22px;
}
</style>
